import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

/**
 * 是否移动端（视口宽度 <= 1023）
 *
 * 注意：SSR/SSG 时服务端拿不到视口宽度，useMediaQuery 返回 false；
 * 若客户端首帧直接返回真实值，会与服务端 HTML 产生水合冲突，
 * 真机（iOS Safari 等）上可能停留在错误分支。
 * 因此首帧固定返回 false（与 SSR 一致），挂载后再同步真实值。
 */
const useIsMobile = () => {
  const matches = useMediaQuery({ maxWidth: 1023 });
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(matches);
  }, [matches]);

  return isMobile;
};

export default useIsMobile;
